import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { fetchCreateTaskCounterTemplate } from "../miscellaneous/fetchCreateTaskCounterTemplate";
import { fetchGetCompaniesByParent } from "../../organization-management/miscellaneous/fetchGetCompaniesByParent";
import { fetchGetJobsByCompanyId } from "../../jobs-management/miscellaneous/fetchGetJobsByCompanyId";
import { fetchGetAllParentCompanies } from "../../user-management/miscellaneous/fetchGetAllParentCompanies";

export const useCreateTaskCounterTemplate = () => {
  const [parentCompanies, setParentCompanies] = useState<any[]>([]);
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [jobTitles, setJobTitles] = useState<any[]>([]);

  const navigate = useNavigate();

  const mutationGetParentCompanies = useMutation(fetchGetAllParentCompanies, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const companies = _.map(res.data.data, (item: any) => {
          return { name: item.companyName, value: item.id };
        });
        setParentCompanies(companies);
      }
    },
    onError: () => {},
  });

  const mutationGetOrganizations = useMutation(fetchGetCompaniesByParent, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const orgs = _.map(res.data.data, (item: any) => {
          return { name: item.companyName, id: item.id };
        });
        setOrganizations(orgs);
      }
    },
    onError: () => {},
  });

  const mutationGetJobTitles = useMutation(fetchGetJobsByCompanyId, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const jobs = _.map(res.data.data ?? [], (item: any) => {
          return { id: item.id, title: item.title };
        });
        setJobTitles(jobs);
      }
    },
    onError: () => {},
  });

  const mutationCreateTemplate = useMutation(fetchCreateTaskCounterTemplate, {
    onSuccess: (res) => {
      if (res.status === 200) {
        navigate("/task-counter");
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    const userRole = !!localStorage.getItem("rolesJson")
      ? JSON.parse(localStorage.getItem("rolesJson") as string)
      : [];

    const isRoleAdmin =
      userRole &&
      userRole.length > 0 &&
      userRole[0]?.Name &&
      userRole[0]?.Name.toLowerCase() === "admin";

    const parentCompanyId = localStorage.getItem("parentCompanyId") ?? "";
    const parentCompanyName = localStorage.getItem("parentCompanyName") ?? "";

    if (isRoleAdmin && parentCompanyId) {
      setParentCompanies([{ value: parentCompanyId, name: parentCompanyName }]);
      mutationGetOrganizations.mutate(parentCompanyId);
    } else {
      mutationGetParentCompanies.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    mutationCreateTemplate,
    mutationGetJobTitles,
    mutationGetOrganizations,
    parentCompanies,
    organizations,
    jobTitles,
  };
};
